import React, { Component } from 'react';
import './index.less';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { FormattedMessage } from 'react-intl';
import Table from './table';
import Form from './form';
import { actUI } from '../../redux/action/ui';
import { PAGE_SIZE, translation } from '../../config';
import CompWrapper from './func';
import { CB_STATUS } from '../../util/fetch/cFetch';
import { msgCB } from '../../util/fetch/msgFetch';
import { localStore, sessionStore } from '../../util/storage';
import {
  getCiamDomain,
  getCiamClientId,
  getCiamRedirectUri,
} from '../../util/url';

let setIntervalID;
let isCode;
export class Page extends Component {
  componentDidMount() {
    console.log('device/index.jsx--init device begin');

    const { dispatch } = this.props;

    this.handleAuth();
    console.log('device/index.jsx--init device end');

    this.handleChangeLanguage();

    actUI(dispatch, {
      uiHome: { uiMenuSider: { uiMenu: { selectedKeys: ['device'] } } },
    });
  }

  componentWillUnmount() {
    clearInterval(setIntervalID);
  }

  actionCallback = () => {
    const { ui, getDevice } = this.props;
    setIntervalID = getDevice(
      { limit: PAGE_SIZE, offset: ui.offset },
      null,
      setIntervalID,
    );
  }

  handleCancel = () => {
    const { dispatch } = this.props;
    actUI(dispatch, { uiDevice: { dialogState: null, dataIndex: null } });
  }

  handleAddClick = () => {
    const { dispatch } = this.props;
    actUI(dispatch, { uiDevice: { dialogState: 'ADD', dataIndex: null } });
  }

  handleEditClick = (index) => {
    const { dispatch } = this.props;
    actUI(dispatch, { uiDevice: { dialogState: 'EDIT', dataIndex: index } });
  }

  handleSubmit = (values, cb) => {
    const { ui, createDevice, editDevice } = this.props;
    const callback = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        this.actionCallback();
        this.handleCancel();
      }
      cb(res);
    };
    switch (ui.dialogState) {
      case 'ADD':
        createDevice(values, callback);
        break;
      case 'EDIT':
        editDevice(values, callback);
        break;
      default:
        break;
    }
  }

  handleOnChange = (values) => {
    const { getDevice } = this.props;
    setIntervalID = getDevice(values, null, setIntervalID);
  }

  handleDelete = (values, cb) => {
    const { deleteDevice } = this.props;
    const callback = (res) => {
      if (res.status === CB_STATUS.SUCCESS) {
        this.actionCallback();
      }
      cb(res);
    };
    deleteDevice(values, callback);
  }

  handleAuth = () => {
    const { getCiamToken } = this.props;
    console.log('handleAuth begin,window.location.href=', window.location.href);
    // console.log('this.props.history.location=', this.props.history.location);
    console.log('auth in sessionStore is :', sessionStore.get('auth'));
    if (!sessionStore.get('auth')) {
      if (
        window.location.href.indexOf('code=') !== -1
        || sessionStore.get('ciamCode')
      ) {
        console.log('window.location.href=', window.location.href);
        console.log('sessionStore.ciamCode=', sessionStore.get('ciamCode'));
        const code = window.location.href.indexOf('code=') !== -1
          ? decodeURIComponent(
            window.location.href.split('code=')[1].split('&')[0],
          )
          : sessionStore.get('ciamCode');
        console.log('code=', code);
        const callback = (res) => {
          console.log('callback of getCiamToken', res);
          if (res.status === CB_STATUS.SUCCESS) {
            this.handleInterval();
          }
          // cb(res);
          console.log(
            'auth in sessionStore after callback is :',
            sessionStore.get('auth'),
          );
        };
        isCode = true;
        getCiamToken(code, callback);
      } else {
        isCode = false;
        window.location.href = `${getCiamDomain()}/authorize?client_id=${getCiamClientId()}&scope=openid%20profile%20email&redirect_uri=${getCiamRedirectUri()}&response_type=code`;
      }
    } else {
      console.log('auth in sessionStore is :', localStore.get('auth'));
      this.handleInterval();
    }
    console.log('handleAuth end');
  }

  handleChangeLanguage = () => {
    const { dispatch } = this.props;
    console.log('handleChangeLanguage begin');
    // console.log('sessionStore.get(lang):')
    if (sessionStore.get('lang')) {
      console.log('handleChangeLanguage lang=', sessionStore.get('lang'));
      dispatch({
        type: 'INTL_UPDATE',
        payload: {
          locale: sessionStore.get('lang'),
          messages: translation[sessionStore.get('lang')],
        },
      });
    }
    console.log('handleChangeLanguage end');
  }

  handleInterval = () => {
    const {
      intl, ui, getDevice, dispatch,
    } = this.props;
    const callback = (res) => {
      const { formatMessage } = intl;
      msgCB(res.status, formatMessage, { all: false, UNAUTH: true });
      if (ui.uiTable.loading) {
        actUI(dispatch, { uiDevice: { uiTable: { loading: false } } });
      }
    };
    setIntervalID = getDevice(
      { limit: PAGE_SIZE, offset: ui.offset },
      callback,
      setIntervalID,
    );
  }

  render() {
    const {
      intl,
      ui,
      filePath,
      className,
      devices,
      dispatch,
      onDownloadAccount,
    } = this.props;
    const { formatMessage } = intl;
    const { dialogState, dataIndex } = ui;
    if (
      window.location.href.indexOf('code=') !== -1
      || sessionStore.get('ciamCode')
    ) {
      isCode = true;
    } else {
      isCode = false;
    }
    return (
      <div className={`${filePath} ${className}`}>
        {isCode && (
          <div className="addBar">
            <Button
              size="small"
              className="addBtn"
              icon="plus"
              onClick={this.handleAddClick}
            >
              <FormattedMessage
                id="Device.addNewDevice"
                defaultMessage="add new device"
              />
            </Button>
          </div>
        )}
        {isCode && (
          <Table
            data={devices}
            ui={ui.uiTable}
            offset={ui.offset}
            onChange={this.handleOnChange}
            onEdit={this.handleEditClick}
            onDelete={this.handleDelete}
            onDownloadAccount={onDownloadAccount}
            className="table"
            dispatch={dispatch}
          />
        )}
        <Modal
          centered
          closable={false}
          title={
            (dialogState === 'ADD'
              && formatMessage({
                id: 'Device.addNewDevice',
                defaultMessage: 'add new device',
              }))
            || (dialogState === 'EDIT'
              && formatMessage({
                id: 'Device.editNewDevice',
                defaultMessage: 'edit new device',
              }))
          }
          visible={dialogState !== null}
          maskClosable={false}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          okText={formatMessage({ id: 'app.btn.ok', defaultMessage: 'ok' })}
          cancelText={formatMessage({
            id: 'app.btn.cancel',
            defaultMessage: 'cancel',
          })}
          footer={null}
          className="container_device_Main_dialog"
        >
          <Form
            data={
              dataIndex === null ? undefined : devices.results[ui.dataIndex]
            }
            ui={ui.uiForm}
            onSubmit={this.handleSubmit}
            onCancel={this.handleCancel}
            dispatch={dispatch}
          />
        </Modal>
      </div>
    );
  }
}

Page.propTypes = {
  devices: PropTypes.object.isRequired,
  ui: PropTypes.shape({
    dataIndex: PropTypes.number,
    dialogState: PropTypes.string,
    uiTable: PropTypes.object.isRequired,
    uiForm: PropTypes.object.isRequired,
    offset: PropTypes.number.isRequired,
  }).isRequired,
  createDevice: PropTypes.func.isRequired,
  editDevice: PropTypes.func.isRequired,
  deleteDevice: PropTypes.func.isRequired,
  getDevice: PropTypes.func.isRequired,
  getCiamToken: PropTypes.func.isRequired,
  onDownloadAccount: PropTypes.func.isRequired,
  filePath: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default CompWrapper(Page, 'container_Device');
